import React from 'react';
import { useLocation } from 'react-router-dom';

import QuickActionsPanel from './QuickActionsPanel';
import { buildPilatesQuickActions } from 'sectors/pilates/quickActions/buildPilatesQuickActions';
import { useQuickActionsBridge } from 'shared/ui/QuickActions/QuickActionsBridge';
import TakePaymentModal from 'sectors/pilates/payments/modal/TakePaymentModal';

function resolveBuilder(pathname = '') {
  if (pathname.startsWith('/app/pilates')) return 'PILATES';
  return null;
}

export default function GlobalQuickActions() {
  const { pathname } = useLocation();
  const { registry } = useQuickActionsBridge();

  // ✅ modal state burada
  const [takePaymentOpen, setTakePaymentOpen] = React.useState(false);

  // ✅ registry'yi override ederek payments handler ekliyoruz
  const actionsApi = React.useMemo(() => {
    return {
      ...registry,
      payments: {
        ...(registry?.payments || {}),
        openTakePayment: () => setTakePaymentOpen(true),
      },
    };
  }, [registry]);

  const config = React.useMemo(() => {
    const type = resolveBuilder(pathname);
    if (type === 'PILATES') {
      return buildPilatesQuickActions({
        pathname,
        actionsApi, // ✅ artık payments var
      });
    }
    return null;
  }, [pathname, actionsApi]);

  if (!config) return null;

  return (
    <>
      <QuickActionsPanel {...config} defaultOpen={false} />

      <TakePaymentModal open={takePaymentOpen} onClose={() => setTakePaymentOpen(false)} />
    </>
  );
}
